import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, funValidateNoInput, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetailParams } from "../../state/lotMasterSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { useModalToast } from "../../components/modalToast/ModalToastContext";
import { funNormalizeInput } from "../../Utility/utility";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"



const CreateLotEntry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode, isMultipleCompany } = useSelector((state) => state.company)
    const [submitBtnId, setSubmitBtnId] = useState("")
    const { detailParams, isNewEntry } = useSelector((state) => state.lotMaster);
    const { show } = useModalToast();
      const submitLockRef = useRef(false);//

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])
    const [formData, setFormData] = useState({
        lotCode: "",
        lotName: "",
        pCarat: "",
        demPcs: "",
        demCarat: "",
        inwDate: null,
        lotPcs: "",
        lotWeight: "",
        lotPolAvg: "",
        lotPolAvgRs: "",
        polCnvRate: "",
        lotCost: ""
    });

    const { data: detail = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.lotMaster.fetchEntryDetail,
        queryKey: "fetchLotMasterdetail",
    });

    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {

            filterDetail({
                data: {
                    lot_code: detailParams.lot_code,
                    comp_code: detailParams.comp_code
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && detail && detail.length > 0) {
            setFormData({
                lotCode: detail[0].L_Code || "",
                lotName: detail[0].L_Name || "",
                lotPcs: detail[0].L_Pcs || 0,
                lotWeight: detail[0].L_Carat || 0,
                lotPolAvg: detail[0].LotPolAvg || 0,
                polCnvRate: detail[0].Pol_Cnv_Rate || 0,
                lotPolAvgRs: detail[0].LotPolAvgRs || 0,
                inwDate: detail[0].L_InwardDate || null,
                pCarat: detail[0].P_Carat || 0,
                demCarat: detail[0].Dem_Carat || 0,
                demPcs: detail[0].Dem_Pcs || 0,
                lotCost: detail[0].LotCost || 0,
            });
            // console.log(shapeDetails.S_Code, isNewEntry, formData)

        }
    }, [detail]);
    const handleChange = (e) => {
        const { value, name } = e.target
        if (['lotCode', 'lotName'].includes(name))
            setFormData({ ...formData, [name]: value });
        else {
            if (funValidateNoInput(value))
                setFormData({ ...formData, [name]: value });
        }
    };

    const { mutate: funAddUpdate, isPending, isError } = usePost({
        queryKey: "LotMasterAddUpdate",
        url: apiRoute.lotMaster.add_update,
        onSuccessTasks: () => {
            dispatch(resetDetailParams());
            submitLockRef.current = false;
            if (submitBtnId == 'btnSaveNew') {
                setFormData({
                    lotCode: "",
                    lotName: "",
                    lotPcs: "",
                    lotWeight: "",
                    lotPolAvg: "",
                    polCnvRate: '',
                    lotPolAvgRs: "",
                    lotCost: ""
                })
            }
            else
                navigate(linksUrl.master.lot.lotMaster);
        },
    });


    const { mutate: funChkDupLotCode } = usePost({
        queryKey: "checkLotCode",
        url: apiRoute.lotMaster.checkLotCode,
        onSuccessTasks: (data) => {
            console.log(data)
            if (data && data.length > 0) {
                show("Lot Code Exists Enter Another")
                setFormData({ ...formData, lotCode: "" })
            }

        }
    });

    const handleBlur = (e) => {
        const { name, value } = e.target;
        funChkDupLotCode({
            data: {
                lot_code: value,
                comp_code: compCode.join(",")
            }
        })

    }
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
         if (submitLockRef.current) return;
    submitLockRef.current = true;
        funAddUpdate({
            data: {
                compCode: compCode.join(","),
                ...formData,
                login_userid: user.username,
                rec_status: !isNewEntry ? 1 : 2,
            }
        });

    };



    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <MainContainer
            pageName="Lot Master Entry"
            breadcrumbs={["Master", "Lot Master Entry"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.master.lot.lotMaster) }}
        >
            {/* <Card className="p-6"> */}
            <Card shadow="sm" radius="sm" className="mb-3  h-[calc(100vh-118px)]  overflow-y-auto">

                <form onSubmit={handleSubmit}>
                    <CardBody>
                        <div className="p-2">
                            <div className="flex gap-2 mb-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center  justify-center">


                                <Input label="Lot Code" variant="bordered" type="text"
                                    className=" font-semibold text-slate-700" size="sm"
                                    disabled={isNewEntry ? false : true} name="lotCode"
                                    value={formData.lotCode} onChange={handleChange}
                                    onBlur={handleBlur}
                                    isRequired />
                                <Input label="Lot Name" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" name="lotName" type="text"
                                    value={formData.lotName} onChange={handleChange} />
                            </div>
                            <div className="flex gap-2 mb-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center  justify-center">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={"Inw Date"}
                                        views={["day", "month", "year"]}
                                        size="small"
                                        className="w-full"
                                        format="DD/MM/YYYY"
                                        value={
                                            formData.inwDate
                                                ? dayjs(formData.inwDate)
                                                : formData.inwDate
                                        }
                                        onChange={(newValue) => {
                                            setFormData((prev) => {
                                                return {
                                                    ...prev,
                                                    inwDate: newValue != '' && newValue != 'Invalid Date' ?
                                                        dayjs(newValue).format("YYYY-MM-DD") : null,
                                                };
                                            });
                                        }}
                                        slotProps={{
                                            textField: { size: "small", },
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="flex gap-2 mb-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center  justify-center">
                                <Input label="Lot Pcs" variant="bordered"
                                    className="font-semibold text-slate-700" size="sm"
                                    type="text" name="lotPcs" value={formData.lotPcs} onChange={handleChange} />
                                <Input label="Lot Weight" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" type="text" name="lotWeight" value={formData.lotWeight} onChange={handleChange} />
                            </div>
                            <div className="flex gap-2 mb-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center  justify-center">

                                <Input label="Polish Cost" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" type="text" name="lotCost" value={formData.lotCost} onChange={handleChange} />
                                <Input label="Polish Carat" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" type="text" name="pCarat" value={formData.pCarat} onChange={handleChange} />
                            </div>
                            <div className="flex gap-2 mb-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center  justify-center">
                                <Input label="Demand Carat" variant="bordered"
                                    className="font-semibold text-slate-700" size="sm"
                                    type="text" name="demCarat" value={formData.demCarat} onChange={handleChange} />
                                <Input label="Demand Pcs" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" type="text" name="demPcs" value={formData.demPcs} onChange={handleChange} />
                            </div>
                            <div className="flex gap-2 mb-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center  justify-center">
                                <Input label="Polish Average Rate ($)" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" type="text" name="lotPolAvg" value={formData.lotPolAvg} onChange={handleChange} />

                                <Input label="Polish Average Rate (₹)" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" type="text" name="lotPolAvgRs" value={formData.lotPolAvgRs} onChange={handleChange} />

                            </div>

                            <div className="flex gap-2 mb-2 flex-wrap sm:flex-nowrap md:flex-nowrap items-center  justify-center">
                                <Input label="Polish Conv Rate" variant="bordered" className="font-semibold text-slate-700"
                                    size="sm" type="text" name="polCnvRate" value={formData.polCnvRate} onChange={handleChange} />
                            </div>
                            <div className="flex gap-4 mt-4 items-center justify-center">
                                <Button type="submit" id="btnSave" color="primary" size="sm" isLoading={isPending}>
                                    {isNewEntry ? "Save" : "Update"}
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button size="sm" onPress={() => navigate(linksUrl.master.itemGroup.itemGroupMaster)} color="danger" isLoading={isPending}>
                                    Cancle
                                </Button>
                            </div>
                        </div>
                    </CardBody>
                </form>




            </Card>
        </MainContainer>
    );
};

export default CreateLotEntry;

